<template>
  <apexchart height="250" type="pie" :options="chartOptions" :series="series" />
</template>

<script>
import {
  toPairs,
  compose,
  map,
  last,
  head,
  propOr,
  pickAll,
  defaultTo,
  pathOr
} from "ramda";
import { mapGetters } from "vuex";
const categories = [
  "0_5_percent",
  "6_10_percent",
  "11_50_percent",
  "51_70_percent",
  "mt_70_percent"
];

export default {
  props: {
    chartData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          toolbar: {
            show: false
          }
        },
        labels: this.labels,
        legend: {
          formatter: (seriesName, ops) => {
            const numberOfStudents = pathOr(0, ["chartData", seriesName])(this);
            const token = numberOfStudents === 1 ? "student" : "students";
            const message = this.$t(
              this.$i18nLabelsHelper(this.currentOrganizationType, token)
            );
            const seriesTitle = this.$t(
              `classes.classes_details.activity_reports.${seriesName}`
            );

            return `${seriesTitle}: ${numberOfStudents} ${message}`;
          }
        },
        tooltip: {
          y: {
            formatter: (numberOfStudents) => {
              const token = numberOfStudents === 1 ? "student" : "students";

              const message = this.$t(
              this.$i18nLabelsHelper(this.currentOrganizationType, token))

              return `${numberOfStudents} ${message}`
            },
            title: {
              formatter: (seriesName, ops) => {
                return this.$t(
                  `classes.classes_details.activity_reports.${seriesName}`
                );
              }
            }
          }
        },
        responsive: [
          {
            breakpoint: 768,
            options: {
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      };
    },
    series: compose(
      map(compose(defaultTo(0), last)),
      toPairs,
      pickAll(categories),
      propOr({}, "chartData")
    ),
    labels: compose(
      map(head),
      toPairs,
      pickAll(categories),
      propOr({}, "chartData")
    ),
    ...mapGetters("organization", ["currentOrganizationType"])
  }
};
</script>

<style lang="scss" scoped>
</style>
